// mutation

import { ApiPaths } from "../apiPaths"
import api from "../http"

// update or add
export const postFeedBack = async (data) => {
    return await api({
        url: ApiPaths.postFeedBack,
        method: 'post',
        data: {data},
        headers: {
            'Content-Type': 'application/json'
        }
    })
}